import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Part } from '@raptor-fe/core';
import { ServiceUtils } from '../service-utils/service-utils';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class PartService {
    private readonly http = inject(HttpClient);
    private readonly serviceUtils = inject(ServiceUtils);

    /**
     * Assigns a scanned barcode to an existing part.
     * The Part controller is tenant-scoped only (no branch segment), so the tenant-only
     * base URL is used here intentionally.
     */
    assignBarcode(tenantId: string, partId: string, value: string): Observable<Part> {
        return this.http.put<Part>(this.serviceUtils.getBaseUrl('part', tenantId) + `/${partId}/barcode`, {
            value,
        });
    }
}
